import { saveToLocalStorage } from "src/localStorage"

const setData = (state, action) => {
  Object.entries(action.payload).forEach(([key, value]) => {
    state[key] = value
  })
  return state
}

const setTokens = (state, action) => {
  state.refreshToken = action.payload.refreshToken
  state.accessToken = action.payload.accessToken
  saveToLocalStorage({ refreshToken: action.payload.refreshToken, accessToken: action.payload.accessToken })
}

/* A refresh answers with a new access token and, where the server rotates refresh tokens (gamekit
   0.11.0), a new refresh token too: the old one is spent, so both are kept. Without a rotated one
   the stored refresh token stays as it is. */
const setAccessToken = (state, action) => {
  state.accessToken = action.payload.accessToken
  const rotated = action.payload.refreshToken
  if (typeof rotated === "string" && rotated) {
    state.refreshToken = rotated
    saveToLocalStorage({ accessToken: action.payload.accessToken, refreshToken: rotated })
  } else {
    saveToLocalStorage({ accessToken: action.payload.accessToken })
  }
}

const reducers = {
  setData,
  setTokens,
  setAccessToken,
}

export default reducers
